import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import './TestimonialsSection.css';
import '../common-styles.css';
import nextIcon from '../../assets/images/icons/next.svg';
import prevIcon from '../../assets/images/icons/previous.svg';

interface Testimonial { id:number; name:string; title:string; rating:number; text:string; avatar:string; }

const testimonials: Testimonial[] = [
  { id:1, name:'Jane Smith', title:'CEO at WebOcean', rating:5, text:'The diamond I purchased from SunDiam is truly stunning—brilliant, well-cut, and exactly as described. I appreciate their transparency and ethical sourcing. Highly recommended!', avatar:'' },
  { id:2, name:'Robert Lee', title:'Founder at NovaTech', rating:5, text:'Impeccable service and unmatched quality. Every interaction felt professional and genuine.', avatar:'' },
  { id:3, name:'Amelia Clark', title:'Luxury Retailer', rating:5, text:'Consistency and brilliance in every parcel we receive. A trusted partner for years.', avatar:'' }
];

const TestimonialsSection: React.FC = () => {
  const [index, setIndex] = useState(0);
  const current = testimonials[index];
  const next = () => setIndex((i)=> (i+1)%testimonials.length);
  const prev = () => setIndex((i)=> (i-1+testimonials.length)%testimonials.length);

  return (
    <section className="testimonials-redesign section">
      <Container>
        <h2 className="testimonials-heading text-center mb-5">
          <span className="section-title-highlight">Words of</span> Appreciation
        </h2>
        <div className="testimonial-shell">
          <button className="ts-nav ts-nav-prev" aria-label="Previous testimonial" onClick={prev}>
            <img src={prevIcon} alt="Previous" />
          </button>
          <div className="testimonial-panel">
            <div className="testimonial-quote-row">
              <i className="fas fa-quote-left quote-mark" />
              <p className="testimonial-text-body">{current.text}</p>
              <i className="fas fa-quote-right quote-mark quote-right" />
            </div>
            <div className="testimonial-author-card">
              <div className="author-left">
                <div className="author-avatar" aria-hidden="true" />
                <div className="author-meta">
                  <div className="author-name">{current.name}</div>
                  <div className="author-title">{current.title}</div>
                </div>
              </div>
              <div className="author-rating" aria-label={`Rating ${current.rating} of 5`}>
                {Array.from({length:5}).map((_,i)=> <i key={i} className={`fas fa-star${i<current.rating?'':' star-empty'}`} />)}
                <span className="rating-score ms-2">{current.rating}/5</span>
              </div>
            </div>
          </div>
          <button className="ts-nav ts-nav-next" aria-label="Next testimonial" onClick={next}>
            <img src={nextIcon} alt="Next" />
          </button>
        </div>
        <div className="testimonial-dots mt-4">
          {testimonials.map((t,i)=>(
            <button key={t.id} className={`dot ${i===index?'active':''}`} aria-label={`Go to testimonial ${i+1}`} onClick={()=>setIndex(i)} />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default TestimonialsSection;
